import { useCallback, useContext } from "react";
import { ModalContext } from "../contexts/ModalContext";
export var useModal = function (modal) {
    var _a = useContext(ModalContext), onDismiss = _a.onDismiss, onPresent = _a.onPresent;
    var handlePresent = useCallback(function () {
        onPresent(modal);
    }, [modal, onPresent]);
    return [handlePresent, onDismiss];
};
